import React, {Component} from 'react';
import Identification from '../../Common/Identification';
import {PageContainer, PageTitle} from '../../Common/PageComponents';
import PageDescription from '../../Common/PageDescription';

class IdentificationPage extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title="보안 관리" data-qa="usagePageTitle">
          Home &gt; MY PC방 &gt; <strong> 보안 관리</strong>
        </PageTitle>
        <PageDescription>
          보안 관리 페이지 접근을 위해 아이핀 또는 휴대폰 인증을 통해 본인인증을 해주세요.
          <br /> 본인인증은 회원 가입 시 본인과 동일한 명의로 본인인증을 진행해야 합니다.
        </PageDescription>
        <Identification nextUrl="/my-pc-bang/authentication-config" />
      </PageContainer>
    );
  }
}

export default IdentificationPage;
